// $(document).on('change', '.selector-wrapper select', function() {
//   var variant_val = $('.variant-selection__variants').val();
//   if(variant_val != null){
//     if(variant_val != '#ffffff'){
//       var variant_color = $('.variant-selection__variants option[value="'+variant_val+'"]').data('variant-color');
//       if(variant_color != undefined){
//         for (let i = 0; i < $('.selector-wrapper select').length; i++) {
//           $($('.selector-wrapper select')[i]).css({'background':''+variant_color+'','color':'white'});
//         }
//       }
//     }else{
//       for (let i = 0; i < $('.selector-wrapper select').length; i++) {
//         $($('.selector-wrapper select')[i]).css({'background':'transparent','color':'black'});
//       }  
//     }
//   }else{
//     for (let i = 0; i < $('.selector-wrapper select').length; i++) {
//       $($('.selector-wrapper select')[i]).css({'background':'transparent','color':'black'});
//     }
//   }
// });

if(window.location.href.includes('products')){
  if(window.location.href.split('variant=')[1] == '' || window.location.href.includes('variant') == false){
    setTimeout(function() { 
      $('.button--add-to-cart .text').text('Choose option');
    }, 2000);
  }
}

